module.exports = __webpack_public_path__ + "img/18_1.af731da7.png";